export default __webpack_public_path__ + "static/media/Annual-1.3d43057e.jpg";